import { useTheme } from './useTheme';
import type { CardDecorationProps, CardMotifVariant, ParticleProps } from './types';
export function CardDecoration(props: CardDecorationProps) {
  const Art = useTheme().seasonPackage.CardEdges;
  return <span className="theme-card-decoration"><Art {...props} /></span>;
}
export function CardMotif(props: { variant: CardMotifVariant }) {
  const Art = useTheme().seasonPackage.CardMotif;
  return <span className="theme-card-motif"><Art {...props} /></span>;
}
export function BackgroundContinuation() {
  const Art = useTheme().seasonPackage.Continuation;
  return <Art />;
}
export function AmbientParticles(props: ParticleProps) {
  const Art = useTheme().seasonPackage.Particles;
  return <Art {...props} />;
}
export function GameEmblemDecoration() {
  const Art = useTheme().seasonPackage.GameEmblemDecoration;
  return <Art />;
}

export type { DecorationVariant } from './types';
